<div style="height: calc(100vh); overflow: auto;" appBlockCopyPaste>
  <app-candidate-header></app-candidate-header>
  <div class="pending-assessments">
    <div class="list-of-user-assessments">
      <mat-card class="header-card mat-elevation-z1">
        <div class="identity">
          <div class="avatar">{{ getInitials() | uppercase }}</div>
          <div class="who">
            <div class="name">{{ assessments?.candidateName }}</div>
            <div class="email">{{ assessments?.email }}</div>
          </div>
        </div>
        <div class="center">
          <div class="block">
            <div class="label">All Assessments</div>
            <div class="value">{{ assessments?.assessments?.length || 0 }}</div>
            <div class="subtext">Includes pending, in‑progress and completed</div>
            <div class="filters">
              <button class="filter-chip" [class.active]="selectedFilter === 'ALL'"
                (click)="setFilter('ALL')">All</button>
              <button class="filter-chip" [class.active]="selectedFilter === 'NEW'"
                (click)="setFilter('NEW')">New</button>
              <button class="filter-chip" [class.active]="selectedFilter === 'IN_PROGRESS'"
                (click)="setFilter('IN_PROGRESS')">In Progress</button>
              <button class="filter-chip" [class.active]="selectedFilter === 'COMPLETED'"
                (click)="setFilter('COMPLETED')">Completed</button>
            </div>
          </div>
        </div>
        <a class="terms" [routerLink]="['/terms-and-conditions']" target="_blank" rel="noopener">Our Terms</a>
      </mat-card>
    </div>
    <div class="list-of-user-assessments" *ngFor="let assessment of filteredAssessments; trackBy: trackByAssessmentId">
      <mat-card class="mat-elevation-z1" [ngClass]="getCardClass(assessment?.status)">
        <div class="assessment-details">
          <div class="item assessment-col">
            <div class="icon-circle"><span class="material-icons">assignment</span></div>
            <div class="text">
              <label>ASSESSMENT NAME</label>
              <div>{{assessment?.name}}</div>
            </div>
          </div>
          <div class="item">
            <label>ENTERPRISE</label>
            <div>{{assessment?.enterpriseName || '-'}}</div>
          </div>
          <div class="item time-col">
            <label>DURATION</label>
            <div *ngIf="assessment.duration">
              <span class="meta-chip meta-chip-time">
                <span class="material-icons meta-icon">schedule</span>
                {{assessment?.duration}} {{assessment?.duration === 1 ? 'min' : 'mins'}}
              </span>
            </div>
          </div>
          <div class="item expires-col">
            <label>INVITED ON</label>
            <div>
              <span class="meta-chip chip-neutral">
                <span class="material-icons meta-icon">event</span>
                {{ assessment?.invitedOn ? (assessment?.invitedOn | date: 'mediumDate') : '-' }}
              </span>
            </div>
          </div>
          <div class="item">
            <label>PROGRESS</label>
            <div>
              <span class="chip" [ngClass]="getProgressChipClass(assessment?.status)">
                <span class="material-icons chip-icon">{{ getProgressIcon(assessment?.status) }}</span>
                {{assessment.status}}
              </span>
            </div>
          </div>
          <div class="item">
            <button mat-flat-button [ngClass]="getActionButtonClass(assessment?.status)"
              [disabled]="assessment.status === 'COMPLETED'" (click)="onActionClick(assessment)">
              {{ getActionButtonLabel(assessment?.status) }}</button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>